import withNavigate from "../../../routes/withNavigate.jsx";
import LeadsContainer from "./LeadsContainer.jsx";
import LeadsStore from "./LeadsStore.js";

export default LeadsStore(withNavigate(LeadsContainer));